import { el, escape } from './dom';
import { LicenseModal } from './LicenseModal';
import { isPro } from '../lib/license';

export type PricingProps = {
  /** Stripe Checkout URL. */
  proLink?: string;
};

const STRIPE_DEFAULT = 'https://buy.stripe.com/6oU14mbnl5CRdUe1y06Zy00';

export const Pricing = (props: PricingProps = {}): HTMLElement => {
  const proHref = escape(props.proLink ?? STRIPE_DEFAULT);
  const proActive = isPro();

  const proCardBottom = proActive
    ? `<div class="pro-active mono">pro active · thanks!</div>`
    : `<a class="price-card-cta" href="${proHref}" target="_blank" rel="noopener noreferrer">get pro for $19 →</a>
       <button type="button" class="price-card-key" data-action="have-key">already have a key?</button>`;

  const root = el(`
    <section class="pricing" id="pricing">
      <div class="container">
        <div class="section-header">
          <span class="label">pricing</span>
          <h2>simple, honest, cheap<span class="accent-period">.</span></h2>
        </div>

        <div class="pricing-grid">
          <div class="price-card free">
            <div class="price-card-header">
              <span class="price-card-name">free</span>
              <span class="price-card-cost">$0</span>
            </div>
            <div class="price-card-meta">forever, no signup</div>
            <ul class="price-card-features">
              <li>5 free redactions, lifetime</li>
              <li>10 MB file limit</li>
              <li>batch up to 3 files</li>
              <li>all 12 detection types</li>
              <li>PDF and image support</li>
            </ul>
          </div>

          <div class="price-card pro">
            <div class="price-card-header">
              <span class="price-card-name">pro</span>
              <span class="price-card-cost">$19 once</span>
            </div>
            <div class="price-card-meta">everything in free, plus</div>
            <ul class="price-card-features">
              <li>unlimited redactions</li>
              <li>100 MB file limit</li>
              <li>unlimited batch processing</li>
              <li>manual redaction (drag, highlight)</li>
            </ul>
            ${proCardBottom}
          </div>
        </div>
      </div>
    </section>
  `);

  root
    .querySelector<HTMLButtonElement>('[data-action="have-key"]')
    ?.addEventListener('click', () => {
      const modal = LicenseModal({
        onActivated: () => {
          const card = root.querySelector('.price-card.pro');
          if (card) {
            card.querySelector('.price-card-cta')?.replaceWith(
              el(`<div class="pro-active mono">pro active · thanks!</div>`),
            );
            card.querySelector('.price-card-key')?.remove();
          }
        },
        onClose: () => undefined,
      });
      document.body.append(modal);
    });

  return root;
};
